var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMember(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6654 22.75V20.5833C21.6654 19.4341 21.2088 18.3319 20.3962 17.5192C19.5835 16.7065 18.4813 16.25 17.332 16.25H8.66536C7.51609 16.25 6.41389 16.7065 5.60123 17.5192C4.78858 18.3319 4.33203 19.4341 4.33203 20.5833V22.75",
    stroke: "current",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0013 11.9167C15.3945 11.9167 17.3346 9.97657 17.3346 7.58333C17.3346 5.1901 15.3945 3.25 13.0013 3.25C10.6081 3.25 8.66797 5.1901 8.66797 7.58333C8.66797 9.97657 10.6081 11.9167 13.0013 11.9167Z",
    stroke: "current",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMember);
export default __webpack_public_path__ + "static/media/member.a96cbe5cff887bc6769bcf69b4a9d673.svg";
export { ForwardRef as ReactComponent };